export default __webpack_public_path__ + "static/media/Kayla_Rodriguez_Graff_AHV_In_Moms_We_Trust.84c55371.jpg";